/* @flow */

import type { State } from 'src/shared/core/type/reduxTypes';

export function getBraindateNotificationCount(state: State): number {
  return state.app.notification.braindateCount;
}
